Vue.component('vq-notifications', {
  delimiters: ['[[', ']]'],
  mixins: [ eventHubMixin ],
  // delimiters: ['[[', ']]'],
  data() {
    return {
      timeout: 5000,
      notifications: []
    };
  },
  mounted() {
    this.eventHub.$on('notifications:add', data => {
      this.add(data)
    })

    this.eventHub.$on('notifications:addSuccess', () => {
      this.add({
        theme: 'is-success',
        title: 'Message envoyé',
        content: 'Nous vous répondrons dans les plus brefs délais'
      })
    })

    this.eventHub.$on('notifications:addError', () => {
      this.add({
        theme: 'is-danger',
        title: 'Erreur',
        content: 'Merci de compléter le formulaire en intégralité'
      })
    })
  },
  methods: {
    add(data) {
      const index = this.notifications.length;
      this.notifications.push(data)

      setTimeout(() => {
        this.close(index);
      }, this.timeout)
    },

    close(index) {
      this.notifications.splice(index, 1);
    },
  },
  computed: {
  //   notification() {
  //     return this.$store.state.alertsNotifications.notifications;
  //   },
  },
  
  template: `<div class="notifications">
    <div class="notifications-container">
    <transition-group name="notification">
        <div
        class="notification"
        v-for="(notification, index) in notifications"
        v-on:click="close(index)"
        :class="notification.theme"
        :key="index + 0">

        <p class="notification-title" v-if="notification.title">[[ notification.title ]]</p>
        <div class="notification-content" v-if="notification.content" v-html="notification.content"></div>
        <!-- <p class="date">[[ notification.date ]]</p>
        <a class="more"
            v-on:click.stop
            href="https://www.google.fr"
            target='_blank'>En savoir plus
        </a> -->
        </div>
    </transition-group>
    </div>
</div>
`
})